import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import DataTable from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import Loading from "../../components/loading";
import {deleteUser, fetchDataUser} from "../../services/userService";
import {Context} from "../../context/SearchContext";
import {useContext} from "react";
import SearchInput from "../../components/search/SearchInput";
import {toast} from "react-toastify";
import {CheckBadgeIcon, CheckCircleIcon, CheckIcon} from "@heroicons/react/20/solid";
import {action, updateItem} from "../../services/service";

const headerTable = [
    "id",
    "date",
    "table.user.full_name",
    "table.user.username",
    "table.user.phone",
    "table.user.role",
    "isChecked",
    "workshopId",
    // <span className="sr-only">Edit</span>,
];

const bodyTable = ["id", "createdDate", "fullName", "username", "phone", "role", "isChecked", "workshopId",/* "actions"*/];

const MobileUser = ({t}) => {
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [forcePage, setForcePage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const ctx = useContext(Context);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const fetchData = async () => {
        const response = await fetchDataUser(
            `${process.env.REACT_APP_HOST_BASE_URL}/v2/mobile-user/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        // console.log((response))
        if (response.success) {
            setIsLoading(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    ...item,
                    isChecked: ( !item.isChecked ?
                      <>
                        {item.isChecked?.toString()}
                        <button
                          className="mr-3 text-teal-500 duration-300 ease-in-out hover:text-teal-900 "
                          onClick={()=> onCheckClick(item)}
                        >
                            <CheckCircleIcon className="w-4 h-4"/>
                        </button>
                      </>: item.isChecked.toString()
                    )
                };
            });
            console.log(reviewData);
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const onCheckClick = async (item) => {
        const responseReceived = await swal({
            title: t(`action.checked.title`),
            text: t(`action.checked.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/mobile-user/update/is-checked`;
            let res = await updateItem(url, token, {id: item.id, isChecked: true});
            if (res.success) {
                fetchData();
                setIsLoading(false);

            } else {
                navigate("/error", {
                    state: {
                        status: res.status,
                        message: res.message ? res.message : null,
                    },
                });
            }
        }
    };
    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <div className="px-4 py-4 sm:px-6 lg:px-8">
                    <div className="mb-2 sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-xl font-semibold text-gray-900">
                                {t(`table.user.user_table`)}
                            </h1>
                        </div>
                        {/*<AddButton title={t(`table.user.add_user`)} url={"add"}/>*/}
                    </div>

                    <div>
                        <div className="flex justify-between items-center">
                            <Select
                                setItemsPerPage={setItemsPerPage}
                                itemsPerPage={itemsPerPage}
                            />
                            <SearchInput/>
                        </div>
                        <DataTable
                            data={data.data}
                            headerTable={headerTable}
                            bodyContent={bodyTable}
                        />
                        <Pagination
                            handlePageClick={handlePageClick}
                            pageCount={data.pageCount}
                            forcePage={forcePage}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default withTranslation()(MobileUser);
